type StreamFormat = 'HLS' | 'DASH';
type DRMTypes = 'playready' | 'widevine' | 'clear' | 'fairplay';
type SupportedStreamFormat = Partial<Record<StreamFormat, DRMTypes[]>>;

const SUPPORTED_STREAM_FORMATS: SupportedStreamFormat[] = [
    { HLS: ['fairplay', 'clear'] },
    {
        DASH: ['playready', 'widevine', 'clear'],
    },
];

export const SupportedStreamFormatHeader = {
    'x-device-supported-stream-formats': JSON.stringify(SUPPORTED_STREAM_FORMATS),
};
